import { Spinner, Text } from '@viapeople/components'

interface KPICardProps {
	title: string
	value: string | null
	suffix?: string
	subtitle?: string
	tooltip?: string
	loading?: boolean
	error?: boolean
	dataTestid?: string
	tone?: 'default' | 'warning' | 'na'
}

export function KPICard({
	title,
	value,
	suffix,
	subtitle,
	tooltip,
	loading,
	error,
	dataTestid,
	tone = 'default',
}: KPICardProps) {
	const isNa = tone === 'na' || value === null

	return (
		<div
			data-testid={dataTestid}
			className={`flex flex-col p-6 border rounded-lg bg-white ${
				tone === 'warning' ? 'border-amber-300 bg-amber-50' : 'border-neutral-200'
			}`}>
			<Text variant='xsmall' className='mb-1 text-neutral-500' title={tooltip}>
				{title}
				{tooltip ? ' ⓘ' : ''}
			</Text>
			{loading ? (
				<div className='py-2'>
					<Spinner />
				</div>
			) : error ? (
				<Text variant='hint' className='py-2 text-red-600' data-testid={`${dataTestid}-error`}>
					Couldn't load this metric. Try a different cycle or refresh the page.
				</Text>
			) : (
				<div className='flex items-baseline gap-1'>
					<Text variant='large' weight='semibold' className={isNa ? 'text-neutral-400' : ''}>
						{isNa ? 'N/A' : value}
					</Text>
					{!isNa && suffix && (
						<Text variant='small' className='text-neutral-500'>
							{suffix}
						</Text>
					)}
				</div>
			)}
			{subtitle && (
				<Text variant='hint' className='mt-1 text-neutral-500'>
					{subtitle}
				</Text>
			)}
		</div>
	)
}
